import { useEffect } from 'react';

/**
 * The one <title> in client/index.html is all three apps get: the SPA routes on
 * the path and the hash without ever touching document.title, so a vet with the
 * console, the portal and the funnel open has three tabs all reading "PawsFree".
 *
 * Every screen names itself as `<page> | <section>` — "Users | Admin",
 * "Profile | My Account" — which is the part a truncated tab still shows.
 */
export const BRAND = 'PawsFree';

/**
 * Section suffixes. Kept here rather than passed as free strings so the three
 * shells can't drift into "Account" / "My account" / "Portal" for the same app.
 */
export const SECTION = {
  admin: 'Admin',
  account: 'My Account',
  welcome: BRAND,
} as const;

export type TitleSection = (typeof SECTION)[keyof typeof SECTION];

/**
 * Sets `document.title` to `<title> | <section>` for as long as the caller is
 * mounted, falling back to the bare brand when the page has no name yet (a
 * shell still resolving who the visitor is).
 *
 * Deliberately does NOT restore the previous title on unmount: the shells swap
 * one screen for the next, and restoring would race the incoming screen's own
 * effect and leave the tab showing the page the visitor just left.
 */
export function useDocumentTitle(title: string | null | undefined, section: TitleSection = BRAND): void {
  useEffect(() => {
    // A page whose own name already carries the section — "Install PawsFree" on
    // the funnel — stands alone rather than saying it twice.
    document.title = !title ? BRAND : title.includes(section) ? title : `${title} | ${section}`;
  }, [title, section]);
}
